import React from 'react';
import ReactPlayer from 'react-player';

import './PostPage.css';

const PostPage2 = ({ srcc, title, author, content }) => {


    return (
        <div className='post-con'>
            <div className='frame'>

                <iframe className="if" src={srcc} allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>
            </div>

            <div className='post-title'>{title}</div>
            <div className='post-author'>{author}</div>
            <div className='post-content'>{content}</div>
        </div>
    );
};

export default PostPage2;
